<div
  cdk-overlay-origin
  class="mat-time-picker-trigger"
  tabindex="0"
  role="button"
  [attr.aria-label]="translations.AriaLabelTimePickerOpen | translate"
  [attr.aria-expanded]="isPanelOpen"
  (click)="togglePanel()"
  (keydown.enter)="togglePanel()"
  (keydown.space)="togglePanel(); $event.preventDefault()"
  #origin="cdkOverlayOrigin"
  #trigger
>
  {{ triggerValue || '\u00A0' }}
</div>

<ng-template
  cdk-connected-overlay
  cdkConnectedOverlayLockPosition
  cdkConnectedOverlayHasBackdrop
  cdkConnectedOverlayBackdropClass="cdk-overlay-transparent-backdrop"
  [cdkConnectedOverlayScrollStrategy]="_scrollStrategy"
  [cdkConnectedOverlayOrigin]="origin"
  [cdkConnectedOverlayOpen]="isPanelOpen"
  [cdkConnectedOverlayPositions]="_positions"
  [cdkConnectedOverlayOffsetY]="_offsetY"
  (backdropClick)="close()"
  (attach)="onAttached()"
  (detach)="close()"
>
  <div class="mat-time-picker-panel-wrap" [@transformPanelWrap] [class.scalable]="isScalable" cdkTrapFocus cdkTrapFocusAutoCapture="true">
    <div
      #panel
      tabindex="-1"
      class="mat-time-picker-panel"
      [@transformPanel]="'opened'"
      (@transformPanel.done)="_panelDoneAnimatingStream.next($event.toState)"
      (keydown.escape)="close(); $event.stopPropagation()"
    >
      <div class="mat-time-picker-input-container">
        @if (isDaysEnabled) {
          <input
            [(ngModel)]="valueProcessor.days"
            (ngModelChange)="onDaysValueChanged($event)"
            (wheel)="valueProcessor.onIncreaseDecreaseValue(valuePart.DAY, 1, $event)"
            (blur)="valueProcessor.normalizeValue(valuePart.DAY)"
            #daysInput
            (focus)="daysInput.select()"
            nimbusMatTimeNumber
            spellcheck="false"
            autocomplete="off"
            [attr.aria-label]="translations.AriaLabelTimePickerDays | translate"
          />
        }
        @if (isHoursEnabled) {
          @if (isDaysEnabled) {
            <div class="mat-time-picker-input-divider">:</div>
          }
          <input
            [(ngModel)]="valueProcessor.hours"
            (ngModelChange)="onHoursValueChanged($event)"
            (wheel)="valueProcessor.onIncreaseDecreaseValue(valuePart.HOUR, 1, $event)"
            (blur)="valueProcessor.normalizeValue(valuePart.HOUR)"
            #hoursInput
            (focus)="hoursInput.select()"
            nimbusMatTimeNumber
            spellcheck="false"
            autocomplete="off"
            [attr.aria-label]="translations.AriaLabelTimePickerHours | translate"
          />
        }
        @if (isMinutesEnabled) {
          @if (isHoursEnabled) {
            <div class="mat-time-picker-input-divider">:</div>
          }
          <input
            [(ngModel)]="valueProcessor.minutes"
            (ngModelChange)="onMinutesValueChanged($event)"
            (wheel)="valueProcessor.onIncreaseDecreaseValue(valuePart.MINUTE, 1, $event)"
            (blur)="valueProcessor.normalizeValue(valuePart.MINUTE)"
            #minutesInput
            (focus)="minutesInput.select()"
            nimbusMatTimeNumber
            spellcheck="false"
            autocomplete="off"
            [attr.aria-label]="translations.AriaLabelTimePickerMinutes | translate"
          />
        }
        @if (isSecondsEnabled) {
          <div class="mat-time-picker-input-divider">:</div>
          <input
            [(ngModel)]="valueProcessor.seconds"
            #secondsInput
            (wheel)="valueProcessor.onIncreaseDecreaseValue(valuePart.SECOND, 5, $event)"
            (blur)="valueProcessor.normalizeValue(valuePart.SECOND)"
            (focus)="secondsInput.select()"
            nimbusMatTimeNumber
            spellcheck="false"
            autocomplete="off"
            [attr.aria-label]="translations.AriaLabelTimePickerSeconds | translate"
          />
        }
      </div>
      <div class="mat-time-picker-actions">
        <button nimbusInvertedButton (click)="onCancelClick()">{{ translations.GeneralCancel | translate }}</button>
        <button nimbusInvertedButton (click)="onSaveClick()" [disabled]="!valueProcessor.isValid">
          {{ translations.GeneralSave | translate }}
        </button>
      </div>
    </div>
  </div>
</ng-template>
